import React, { useEffect, useState } from 'react';
import { Address } from './_Address';
import { CustomerAddress } from '../models/superbit-api-models';
import '../assets/css/simulator_form_p0002.css'
import { SimulatorModel } from '../models/SimulatorModel';

type Props = { closePopup: any; GetPostalCode: any; AddressChange: any; city: string,open:boolean };

const PostalCode = (props: Props) => {
    const [address, setAddress] = useState<CustomerAddress | null>(null);
    const [findSpiner, setFindSpiner] = useState<boolean>(false);


    useEffect(() => {
        if (props.city) {
            var add = address;
            if (add == null) {
                add = new CustomerAddress();
            }
            add.city = "";
            add.street = "";
            add.houseNumber = undefined;
            setAddress(add);
        }
    }, [props.city]);

    useEffect(() => {
        // 
        setFindSpiner(false);
    }, [props.open]);

    const addressChange = async (address: CustomerAddress) => {
        setAddress(address);
        props.AddressChange(address);
    }

    const addressError = async () => {
        // Handle address error
    };

    const closePopup = () => {
        props.closePopup();
        console.log('closePopup')
    }

    const findPostalCode = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setFindSpiner(true);
        if (address != null) {
            var data = await new SimulatorModel().getPostalCode(address.city, address.street, address.houseNumber, address.entry, address.mailbox);
            console.log('findPostalCode-data', data)
            if (data)
                props.GetPostalCode(data.postalCode, address);
            else
                props.GetPostalCode("", address);
        }

    }

    return (
        <>
            <div className="popup-wrapper">
                <section className="popup-window new-subscriber rtl">
                    <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>

                    <div className="popup-content">
                        <div className="popup-header">
                            <div className="popup-title">
                                איתור כתובת
                            </div>
                        </div>
                        <div className="popup-body">
                            <Address
                                addressChange={(data: any) => {
                                    addressChange(data)
                                }}
                                CustomerAddress={address ? address : new CustomerAddress()}
                                addressError={false}
                                showAdditionDetails={false}
                            />
                            <div id="find" className="cell suggestions-btn  " onClick={(e: any) => findPostalCode(e)}>אתר
                                <img src={require("../assets/images/loading.gif")} className={findSpiner ? "loadingGif" : "hide"} />


                            </div>
                        </div>

                    </div>
                </section>
            </div>



        </>
    );
};

export default PostalCode;